import React from 'react';
import { Link } from 'react-router-dom';
import { PawPrint, ArrowLeft, Phone, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-cyan-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-cyan-100">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center gap-3">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
            <PawPrint className="w-7 h-7 sm:w-8 sm:h-8 text-cyan-600 flex-shrink-0" />
            <h1 className="text-lg sm:text-2xl font-bold bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent truncate">
              Mázli Kutyakozmetika
            </h1>
          </Link>
          <Link to="/" className="flex-shrink-0">
            <Button
              variant="outline"
              className="border-2 border-cyan-500 text-cyan-700 hover:bg-cyan-50 font-semibold px-3 sm:px-5 py-2 rounded-full transition-all duration-300"
              data-testid="back-to-home-btn">
              <ArrowLeft className="w-4 h-4 sm:mr-2" />
              <span className="hidden sm:inline">Vissza a főoldalra</span>
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <section className="py-12 sm:py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8 sm:mb-10">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">
                Adatkezelési Tájékoztató
              </h1>
            </div>

            <Card className="shadow-xl border-2 border-cyan-100">
              <CardContent className="p-6 sm:p-8 md:p-12 space-y-6 sm:space-y-8 text-gray-700 leading-relaxed">
                <p className="text-base sm:text-lg">
                  A <strong className="text-cyan-700">Mázli Kutyakozmetika (Orbán Renáta E.V.)</strong> elkötelezett a látogatók és a vendégek személyes adatainak védelme mellett.
                </p>

                <div>
                  <h2 className="text-xl sm:text-2xl font-bold text-cyan-700 mb-4">1. Az Adatkezelő adatai:</h2>
                  <ul className="space-y-2 text-base">
                    <li><strong className="text-gray-800">Név:</strong> Orbán Renáta E.V.</li>
                    <li className="flex items-start gap-2">
                      <MapPin className="w-4 h-4 mt-1 text-cyan-600 flex-shrink-0" />
                      <span><strong className="text-gray-800">Székhely:</strong> 3534 Miskolc, Árpád út 46. 6/1.</span>
                    </li>
                    <li><strong className="text-gray-800">Adószám:</strong> 91570189-1-25</li>
                    <li><strong className="text-gray-800">Nyilvántartási szám:</strong> 61434644</li>
                    <li className="flex items-center gap-2">
                      <Phone className="w-4 h-4 text-cyan-600 flex-shrink-0" />
                      <strong className="text-gray-800">Telefonszám:</strong>
                      <a href="tel:06305441284" className="text-teal-600 font-semibold hover:underline">06 30 544 1284</a>
                    </li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-xl sm:text-2xl font-bold text-cyan-700 mb-4">2. Kezelt adatok köre:</h2>
                  <p>
                    A weboldal látogatása során a szerver automatikusan rögzítheti a látogatók IP-címét és technikai adatait a honlap működése érdekében. Telefonos időpont-egyeztetés során a vendég nevét és telefonszámát kezeljük kizárólag a szolgáltatás teljesítése és kapcsolattartás céljából.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl sm:text-2xl font-bold text-cyan-700 mb-4">3. Az adatkezelés jogalapja és időtartama:</h2>
                  <p>
                    Az adatkezelés jogalapja a látogató hozzájárulása, illetve a szolgáltatás nyújtásához szükséges szerződéses kötelezettség. Az adatokat a kapcsolat fennállásáig vagy a jogszabályok által előírt kötelező ideig őrizzük meg. Az adatokat harmadik félnek nem adjuk át.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl sm:text-2xl font-bold text-cyan-700 mb-4">4. Jogorvoslat:</h2>
                  <p>
                    A látogató bármikor kérheti adatai törlését vagy módosítását a megadott elérhetőségeken. Jogorvoslati kérelemmel a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (NAIH) lehet fordulni.
                  </p>
                </div>

                <div className="border-t border-cyan-100 pt-6 mt-8 text-center">
                  <Link to="/">
                    <Button
                      className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white font-bold px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
                      data-testid="privacy-back-home-btn">
                      <ArrowLeft className="w-5 h-5 mr-2" />
                      Vissza a főoldalra
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-8">
        <div className="container mx-auto px-4 text-center text-gray-400">
          <p>&copy; 2025 Mázli Kutyakozmetika. Minden jog fenntartva.</p>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
